// super simple module for the most common nodejs use case.
exports.markdown = require("./markdown");
exports.parse = exports.markdown.toHTML;



//////////////////
// WEBPACK FOOTER
// ./~/markdown/lib/index.js
// module id = 165
// module chunks = 0